"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDatePickerInput = void 0;
var tslib_1 = require("tslib");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var click_outside_1 = require("../../hooks/click-outside");
var key_event_1 = require("../../hooks/key-event");
var calendar_date_picker_1 = require("../calendar-date-picker");
var input_1 = require("../input");
var padding_1 = require("../padding");
var popper_1 = require("../popper");
function CalendarDatePickerInput(props) {
    var _a = props.autoComplete, autoComplete = _a === void 0 ? false : _a, clearOnDisabled = props.clearOnDisabled, disableWeekends = props.disableWeekends, disabled = props.disabled, value = props.value, isInvalid = props.isInvalid, _b = props.isRequired, isRequired = _b === void 0 ? false : _b, maxDate = props.maxDate, minDate = props.minDate, name = props.name, onChange = props.onChange, fieldId = props.fieldId, propTestId = props.testId, _c = props.format, format = _c === void 0 ? (0, string_formatters_1.getLocalDateInputFormat)() : _c;
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : (0, kebabCase_1.default)(fieldId !== null && fieldId !== void 0 ? fieldId : name);
    var _d = (0, react_1.useState)(false), isOpen = _d[0], setVisible = _d[1];
    var popoverRef = (0, react_1.useRef)(null);
    var triggerRef = (0, react_1.useRef)(null);
    (0, click_outside_1.useOnClickOutside)(popoverRef, function (e) {
        if (isOpen && e.target !== triggerRef.current) {
            setVisible(false);
        }
    });
    var _e = (0, react_1.useState)(function () { return formatValue(format, value); }), inputValue = _e[0], setInputValue = _e[1];
    (0, key_event_1.useKeyEvent)('Tab', function () { return setVisible(false); }, []);
    (0, key_event_1.useKeyEvent)('Enter', function () { return setVisible(false); }, []);
    var resetInputValue = (0, react_1.useCallback)(function () {
        setInputValue(formatValue(format, value));
    }, [value, format]);
    (0, react_1.useEffect)(function () {
        resetInputValue();
    }, [resetInputValue]);
    var onBlur = (0, react_1.useCallback)(function (inputStr) {
        if (inputStr === '') {
            onChange(undefined);
            return;
        }
        var newDate = string_formatters_1.CalendarDate.fromString(inputStr, format);
        if (!newDate) {
            resetInputValue();
        }
        else {
            onChange(newDate);
        }
    }, [format, resetInputValue, onChange]);
    var isValidDate = (0, react_1.useCallback)(function (date) {
        return date.check({
            allowWeekends: !disableWeekends,
            maxDate: maxDate,
            minDate: minDate,
        });
    }, [disableWeekends, maxDate, minDate]);
    return (react_1.default.createElement(popper_1.Popper, { offsetDistance: 4, isOpen: isOpen, placement: "bottom-start", trigger: function (_a) {
            var currentTriggerRef = _a.triggerRef;
            triggerRef.current = currentTriggerRef.current;
            return (react_1.default.createElement(input_1.Input, { disabled: disabled, name: name, innerRef: currentTriggerRef, fieldId: fieldId, testId: testId, onChange: setInputValue, onFocus: function () { return setVisible(true); }, onKeyDown: function (event) {
                    if (event.key === 'Enter') {
                        event.target.blur();
                    }
                }, onBlur: onBlur, placeholder: string_formatters_1.DateInputFormatPlaceholder[format], type: "date", value: clearOnDisabled && disabled ? '' : inputValue, isRequired: isRequired, autoComplete: autoComplete ? 'on' : 'off', isInvalid: isInvalid }));
        } },
        react_1.default.createElement(padding_1.Padding, { size: 8 },
            react_1.default.createElement("div", { ref: function (ref) {
                    popoverRef.current = ref;
                } },
                react_1.default.createElement(calendar_date_picker_1.CalendarDatePicker, { value: value, validate: isValidDate, maxDate: maxDate, minDate: minDate, onChange: function (newDate) {
                        setVisible(false);
                        if (newDate && !isValidDate(newDate))
                            return;
                        if (!value && !newDate)
                            return;
                        if (newDate && value && value.isSameDate(newDate))
                            return;
                        onChange(newDate);
                    } })))));
}
exports.CalendarDatePickerInput = CalendarDatePickerInput;
function formatValue(format, date) {
    if (date) {
        return date.inputFormat(format);
    }
    return '';
}
//# sourceMappingURL=index.js.map